/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/GroupAdd';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const GroupAddIcon = withMuiAdapter(Base, 'GroupAdd');
